module.exports = __webpack_public_path__ + "static/media/05.f569d394.mp3";